import React from 'react';
import './styles.css';

const Loading = ({ loading, loadingColor, backgroundColor }) => (
  <div
    className={`loading-container${loading ? ' loading-visible' : ''}`}
    style={{ background: backgroundColor }}
  >
    <div className="loader">
      <svg className="circular" viewBox="25 25 50 50">
        <circle
          className="path"
          cx="50" cy="50" r="20"
          fill="none"
          strokeWidth="1" strokeMiterlimit="10"
          style={{ stroke: loadingColor }}
        />
      </svg>
    </div>
  </div>
);

Loading.propTypes = {
  loading: React.PropTypes.bool.isRequired,
  loadingColor: React.PropTypes.string.isRequired,
  backgroundColor: React.PropTypes.string.isRequired,
};

export default Loading;



// WEBPACK FOOTER //
// ./src/browser/app/components/Loading/Loading.js